module.exports = __webpack_public_path__ + "static/media/poseCode.63b7b583.svg";